<template>
  <div class="callout callout-primary" v-if="decodedSubtitle || instructions || source">
    <div v-if="convertedInstructions">
      <span>Instruções</span>
      <br />
      <div style="border-style: solid; border-color: #63c2de; padding: 10px;">
        <span v-html="convertedInstructions"></span>
      </div>
    </div>
    <br/>
    <br/>
    <div v-if="decodedSubtitle">
      <span>Sugestão de legenda:</span>
      <br />
      <b-input-group class="mb-">
        <b-form-textarea
          disabled
          class="form-control"
          v-bind:class="{ unselectable: preventSelection }"
          v-model="decodedSubtitle"
          max-rows="15"
        />
        <br/><br/>
      </b-input-group>
    </div>
    <br />
    <b-input-group class="mb-">
      <b-form-textarea
        disabled
        v-if="this.subtitle && (this.subtitle.indexOf('Fonte:')  >= 0 || this.subtitle.indexOf('Fontes:')  >= 0)"
        style="height: 100px;"
        class="form-control"
        v-model="source"
      />
      <br/><br/>
    </b-input-group>
    <br />
    <b-button
    v-clipboard:copy="decodedSubtitle"
    :disabled="preventSelection"
    v-if="!preventCopyButton"
     variant="primary">
      <i class="fa fa-copy"></i> Copiar
    </b-button>
    <b-button
    v-clipboard:copy="decodedSubtitleWithSource"
    :disabled="preventSelection"
    v-if="!preventCopyButton"
    style="margin-left: 10px;"
     variant="primary">
      <i class="fa fa-copy"></i> Copiar com Fonte
    </b-button>
  </div>
</template>

<script>
export default {
  name: "SubtitleBox",
  props: {
    subtitle: undefined,
    preventCopyButton: false,
    preventSelection: false,
    isStory: false,
    instructions: ""
  },
  data() {
    return {
    };
  },
  computed: {
    convertedInstructions: function() {
      if (this.instructions) {
        let instructions = this.instructions.replace(new RegExp("\n", 'g'), "<br/>");
        
        return instructions;
      }
      return false;
    },
    decodedSubtitle: function() {
      if (this.subtitle) {
        let subtitle = this.subtitle.replace(new RegExp("\n \n", 'g'), "\n\n");
        subtitle = subtitle.split("Fonte:")[0];
        let urlEncoded = encodeURI(subtitle);
        
        let urlEnocdedNew = urlEncoded.replace(new RegExp("%0A", 'g'), "%E2%81%A3%0A");
        
        let finalSubtitle =  decodeURI(urlEnocdedNew);
        
        return finalSubtitle;
      }
      return false;
    },
    decodedSubtitleWithSource: function() {
      if (this.subtitle) {
        let subtitle = this.subtitle.replace(new RegExp("\n \n", 'g'), "\n\n");
        
        let urlEncoded = encodeURI(subtitle);
        
        let urlEnocdedNew = urlEncoded.replace(new RegExp("%0A", 'g'), "%E2%81%A3%0A");
        
        let finalSubtitle =  decodeURI(urlEnocdedNew);
        
        return finalSubtitle;
      }
      return false;
    },
    source: function() {
      if (this.subtitle) {
        let subtitle = this.subtitle.replace(new RegExp("\n \n", 'g'), "\n\n");
        let splitSubtitle = subtitle.split("Fonte:");

        if (splitSubtitle.length >= 2) {
          subtitle = "Fonte:" + splitSubtitle[1];
        } else {
          splitSubtitle = subtitle.split("Fontes:");

          if (splitSubtitle.length >= 2) {
            subtitle = "Fontes:" + splitSubtitle[1];
          } else {
            return undefined;
          }
        }

        let urlEncoded = encodeURI(subtitle);
        
        let urlEnocdedNew = urlEncoded.replace(new RegExp("%0A", 'g'), "%E2%81%A3%0A");
        
        let finalSubtitle =  decodeURI(urlEnocdedNew);
        
        return finalSubtitle;
      }
      return false;
    }
  },
  methods: {
    subtitleFocused: function() {

    }
  },
  created: function() {

  }
};
</script>

<style scoped>
.unselectable {
    pointer-events:none;
}
</style>